// public/js/modules/firestore/firestoreShow.js

import { 
    getFirestore, 
    doc, 
    updateDoc, 
    deleteDoc, 
    collection, 
    query, 
    where, 
    limit, 
    getDocs, 
    orderBy,
    onSnapshot 
} from 'https://www.gstatic.com/firebasejs/9.23.0/firebase-firestore.js';

import { getFunctions, httpsCallable } from "https://www.gstatic.com/firebasejs/9.23.0/firebase-functions.js";
import { getApp } from 'https://www.gstatic.com/firebasejs/9.23.0/firebase-app.js';
import { getAuth } from 'https://www.gstatic.com/firebasejs/9.23.0/firebase-auth.js';

export async function scheduleShow(showData) {
    const user = getAuth().currentUser;
    if (!user) throw new Error("Authentication required to schedule shows.");

    try {
        const functions = getFunctions(getApp(), 'us-east1');
        const scheduleShowCallable = httpsCallable(functions, 'scheduleShow');
        const result = await scheduleShowCallable(showData);
        return result.data;
    } catch (error) {
        console.error("Error calling scheduleShow function:", error);
        throw error;
    }
}

export async function updateShow(showId, data) {
    const db = getFirestore();
    const showRef = doc(db, "shows", showId);
    return updateDoc(showRef, data);
}

export async function deleteShow(showId) {
    const db = getFirestore();
    const showRef = doc(db, "shows", showId);
    return deleteDoc(showRef);
}

export async function getCurrentLiveShow() {
    const db = getFirestore();
    const showsRef = collection(db, "shows");
    const q = query(showsRef, where("status", "==", "live"), limit(1));
    const snapshot = await getDocs(q);
}

export async function getNextUpcomingShow() {
    const db = getFirestore();
    const showsRef = collection(db, "shows");
    const q = query(
        showsRef, 
        where("status", "==", "scheduled"), 
        orderBy("startTime", "asc"), 
        limit(1)
    );
    const snapshot = await getDocs(q);
    if (snapshot.empty) {
        return null;
    }
    return { id: snapshot.docs[0].id, ...snapshot.docs[0].data() };
}


export function listenToUpcomingShows(callback) {
    const db = getFirestore();
    const showsRef = collection(db, "shows");
    const q = query(
        showsRef,
        where("status", "in", ["scheduled", "live"]),
        orderBy("startTime", "asc")
    );

    return onSnapshot(q, (snapshot) => {
        const shows = snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
        callback(shows);
    }, (error) => {
        console.error("Error listening to upcoming shows:", error);
    });
}